module.exports = __webpack_public_path__ + "static/img/h4-1.beca01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h4-1.png
// module id = bj6i
// module chunks = 1